import { AssetPermission, Role } from '@gm-commercial/profile-model';
import { VEHICLE_DETAILS_ROUTING_UPDATES_FLAG } from '~/common/models/featureFlags.model';
import { RouteName } from '~/common/models/route.model';
import { lazyWithReload } from '~/common/utils/lazyWithReload';

const VehicleListView = lazyWithReload(
  () => import('~/features/assets/list/VehicleListView')
);

const BatchSummaryView = lazyWithReload(
  () => import('~/features/assets/batch/BatchSummaryView')
);

const VehicleDetailsFlagWrapper = lazyWithReload(
  () =>
    import(
      '~/routes/organizations/vehicles/details/components/VehicleDetailsFlagWrapper'
    )
);

// May not be needed if Vehicle History will be a tab on the Vehicle List page
const BoardingHistoryListView = lazyWithReload(
  () => import('~/features/assets/history/BoardingHistoryListView')
);

const ORGANIZATIONS_VEHICLES_ROUTES = {
  [RouteName.ORGANIZATIONS_VEHICLES]: {
    name: RouteName.ORGANIZATIONS_VEHICLES,
    path: [
      '/organizations/:organizationsId/vehicles',
      '/organizations/:organizationsId/fleets/:fleetsId/vehicles',
      '/organizations/:organizationsId/hubs/:hubsId/vehicles',
      '/organizations/:organizationsId/hubs/:hubsId/fleets/:fleetsId/vehicles',
    ],
    authorizedPerms: [AssetPermission.READ],
    excludedRoles: [Role.OPERATOR],
    element: VehicleListView,
  },
  [RouteName.ORGANIZATIONS_VEHICLES_BATCH]: {
    name: RouteName.ORGANIZATIONS_VEHICLES_BATCH,
    path: [
      '/organizations/:organizationsId/vehicles/batch/:batchId',
      '/organizations/:organizationsId/fleets/:fleetsId/vehicles/batch/:batchId',
      '/organizations/:organizationsId/hubs/:hubsId/vehicles/batch/:batchId',
      '/organizations/:organizationsId/hubs/:hubsId/fleets/:fleetsId/vehicles/batch/:batchId',
    ],
    authorizedPerms: [AssetPermission.READ],
    excludedRoles: [Role.OPERATOR],
    element: BatchSummaryView,
  },
  [RouteName.ORGANIZATIONS_VEHICLES_DETAILS]: {
    name: RouteName.ORGANIZATIONS_VEHICLES_DETAILS,
    path: '/organizations/:organizationsId/vehicles/:assetsId',
    authorizedPerms: [AssetPermission.READ],
    excludedRoles: [Role.OPERATOR],
    element: VehicleDetailsFlagWrapper,
    requiredFeatureFlags: [VEHICLE_DETAILS_ROUTING_UPDATES_FLAG],
  },
  [RouteName.ORGANIZATIONS_VEHICLES_DETAILS_LOCATION]: {
    name: RouteName.ORGANIZATIONS_VEHICLES_DETAILS_LOCATION,
    path: '/organizations/:organizationsId/vehicles/:assetsId/location',
    authorizedPerms: [AssetPermission.READ],
    excludedRoles: [Role.OPERATOR],
    element: VehicleDetailsFlagWrapper,
    requiredFeatureFlags: [VEHICLE_DETAILS_ROUTING_UPDATES_FLAG],
  },
  [RouteName.ORGANIZATIONS_VEHICLES_DETAILS_TRIPS]: {
    name: RouteName.ORGANIZATIONS_VEHICLES_DETAILS_TRIPS,
    path: '/organizations/:organizationsId/vehicles/:assetsId/trips/:tripId?',
    authorizedPerms: [AssetPermission.READ],
    excludedRoles: [Role.OPERATOR],
    element: VehicleDetailsFlagWrapper,
    requiredFeatureFlags: [VEHICLE_DETAILS_ROUTING_UPDATES_FLAG],
  },
  [RouteName.ORGANIZATIONS_VEHICLE_BOARDING_HISTORY]: {
    name: RouteName.ORGANIZATIONS_VEHICLE_BOARDING_HISTORY,
    path: [
      '/organizations/:organizationsId/vehicles/boarding-history',
      '/organizations/:organizationsId/fleets/:fleetsId/vehicles/boarding-history',
      '/organizations/:organizationsId/hubs/:hubsId/vehicles/boarding-history',
      '/organizations/:organizationsId/hubs/:hubsId/fleets/:fleetsId/vehicles/boarding-history',
    ],
    authorizedPerms: [AssetPermission.READ],
    excludedRoles: [Role.OPERATOR],
    element: BoardingHistoryListView,
  },
};

export default ORGANIZATIONS_VEHICLES_ROUTES;
